import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import tscStyles from '../constants/TscStyles';
import { getClassName } from '../utils/get-class-name';
import TscProgressLabelType from '../constants/TscProgressLabelType';
var Container = styled.div.withConfig({
  displayName: "StatusIndicator__Container"
})(["display:flex;justify-content:center;align-items:center;min-width:5rem;width:100%;height:100%;"]);
var Progress = styled.progress.withConfig({
  displayName: "StatusIndicator__Progress"
})(["-webkit-appearance:none;-moz-appearance:none;appearance:none;flex:1 1 auto;height:100%;color:", ";border:none;min-width:0;::-webkit-progress-bar{background-color:", "}::-webkit-progress-value{background-color:", ";}::-moz-progress-bar{background-color:", ";}::-ms-fill{border:none;}"], function (props) {
  return props.color;
}, tscStyles.color.text.lightMedium, function (props) {
  return props.color;
}, function (props) {
  return props.color;
});
var CountContainer = styled.div.withConfig({
  displayName: "StatusIndicator__CountContainer"
})(["flex:0 0 auto;min-width:3rem;margin-left:.5rem;text-align:center;"]);

var StatusIndicator = function StatusIndicator(_ref) {
  var _ref$cautionCount = _ref.cautionCount,
      cautionCount = _ref$cautionCount === void 0 ? 0 : _ref$cautionCount,
      className = _ref.className,
      max = _ref.max,
      _ref$labelType = _ref.labelType,
      labelType = _ref$labelType === void 0 ? TscProgressLabelType.count : _ref$labelType,
      style = _ref.style,
      value = _ref.value,
      _ref$warningCount = _ref.warningCount,
      warningCount = _ref$warningCount === void 0 ? 0 : _ref$warningCount;
  var color;
  var showCaution = cautionCount !== 0 ? value >= cautionCount : value >= max - 1;
  var showWarning = warningCount !== 0 ? value >= warningCount : value >= max;

  if (showWarning) {
    color = tscStyles.color.message.warning;
  } else if (showCaution) {
    color = tscStyles.color.message.caution;
  } else {
    color = tscStyles.color.message.affirmative;
  }

  var countString = labelType === TscProgressLabelType.count ? "".concat(value, "/").concat(max) : "".concat((value / max * 100).toFixed(0), "%"); // we could expose the fixed precision percentage someday if needed
  // Note - Progress max must come before value or IE11 and Edge will not render the initial content correctly

  return _jsxs(Container, {
    className: getClassName(className, null, 'status-indicator-container'),
    style: style,
    children: [_jsx(Progress, {
      className: getClassName(className, 'progress'),
      max: max,
      value: value,
      color: color
    }), _jsx(CountContainer, {
      className: getClassName(className, 'count-container'),
      children: countString
    })]
  });
};

var StatusIndicatorTest = {
  Container: Container,
  Progress: Progress,
  CountContainer: CountContainer
};
export { StatusIndicator, StatusIndicatorTest };
export default StatusIndicator;